import { DISCOVER, ERRORLIST, ITC } from "../../util/eventTypes"
import BaseEvent from "../../util/baseEvent"
import httpService from "./httpService"
const Config = {
  maxExcludeEp: 3
}
var NodeStatusFlag
;(function(NodeStatusFlag) {
  NodeStatusFlag[(NodeStatusFlag["OK"] = 1)] = "OK"
  NodeStatusFlag[(NodeStatusFlag["OVERLOAD"] = 2)] = "OVERLOAD"
})(NodeStatusFlag || (NodeStatusFlag = {}))
// 查询IDC是否可能
class FetchWebsocketService extends BaseEvent {
  constructor(options = {}) {
    super()
    this.options = options
    this.httpService = httpService
    this.excludedEP = []
    this.$logger.setPrefix("fetchWebsocketService")
  }
  /**
   * Exclude EP address
   * @param {string} ep ws address
   */
  excludeWs(ep) {
    const list = this.excludedEP
    if (list.indexOf(ep) < 0) {
      this.excludedEP.unshift(ep)
    }
    if (list.length > Config.maxExcludeEp) {
      list.pop()

      this.$logger.info("add_exception_ws", {
        title: ep,
        data: `excluded EP list: ${list.join(",")}`,
        event_steps: "fetch_socket"
      })
    }
  }
  /**
   * Fetch ws address
   * @param {string} ep
   */
  fetch(ep) {
    let wsAddress
    const excludedEps = this.excludedEP.join(",")

    this.$logger.info("start_fetch_socket", {
      title: ep,
      data: `excluded EP list: ${excludedEps}`,
      event_steps: "fetch_socket"
    })
    this.httpService
      .findIdcService(ep, excludedEps)
      .then(({ data }) => {
        let isSuccess = false
        const extra = {
          event_steps: "fetch_socket",
          title: ep,
          errorcode: "FETCH_WS_FAIL",
          error_msg: `code:${data.flag}`
        }
        switch (data.flag) {
          case NodeStatusFlag.OK:
            wsAddress = data.data
            isSuccess = true
            break
          case NodeStatusFlag.OVERLOAD:
            this.eventEmitter.emit(ITC.ERROR, ERRORLIST.EP_NODE_OVERLOAD, extra)
            break
          default:
            this.eventEmitter.emit(ITC.ERROR, ERRORLIST.FETCH_WS_FAIL, extra)
            break
        }
        return isSuccess
      })
      .catch(thrown => {
        this.$logger.error(ERRORLIST.FETCH_WS_FAIL, {
          event_steps: "fetch_socket",
          title: ep,
          message: thrown.message
        })
        this.eventEmitter.emit(ITC.ERROR, ERRORLIST.FETCH_WS_FAIL, {
          event_steps: "fetch_socket",
          title: ep,
          message: thrown.message
        })
        return false
      })
      .then(flag => {
        if (flag) {
          this.$logger.info(DISCOVER.FETCH_WS_SERVICE_SUCCESS, {
            event_steps: "fetch_socket",
            title: ep,
            host: wsAddress
          })
          this.eventEmitter.emit(ITC.FETCH_WS_SERVICE_SUCCESS, wsAddress, ep)
        }
      })
  }
}
FetchWebsocketService.Config = Config
export default FetchWebsocketService
// # sourceMappingURL=fetchWebsocketService.js.map
